import "../jquery-ui";
import {industry_selector_list} from "./view_helpers/industry_selector_list";

$(function() {
  const selector = '#user_company_attributes_industry';

  const handleAutocomplete = (source) => {
    return (request, response) => {
      let term = request.term.toLowerCase();
      let exactMatching = []
      let nearMatching = []

      source.forEach(function (elem) {
        elem.toLowerCase().trim() == term
          ? exactMatching.push(elem)
          : elem.toLowerCase().includes(term) && nearMatching.push(elem)
      });

      response(exactMatching.concat(nearMatching));
    };
  };

  const validateInput = (selector, source) => {
    let typedValue = $(selector).val();
    if(typedValue && typedValue !== '') {
      handleAutocomplete(source)({ term: typedValue }, result => {
        if (!result.length || (typedValue !== result[0])) $(selector).val(null);
      });
    }
  }

  const searchAutocomplete = $(selector).autocomplete({
      classes: { [`ui-autocomplete`]: `autocomplete-country-select-list` },
      minLength: 0,
      source: handleAutocomplete(industry_selector_list),
      select: function (event, ui) {
        $(selector).val(ui.item.label)
        validateInput(selector, industry_selector_list);
        return false;
      },
      close: function (event, ui) { validateInput(selector, industry_selector_list) },
      change: function (event, ui) { validateInput(selector, industry_selector_list) },
    }
  );

  searchAutocomplete.on('focus', function () {
    $(this).autocomplete("search");
  })
})